/**
 * 生产环境语音网关：wss://big-model-debug.gooki.com/ws
 */
module.exports = {
  env: 'online',
  scheme: 'wss',
  host: 'big-model-debug.gooki.com',
  path: '/ws',
  proxyPath: '/voice-ws',
  apiKey: 'sk-1d4fab85e8588583c71947ec8d65516d4e45bfd1e2bb7819ebf38dd8e2c7a03b',
  debugScriptReleaseId: '0',
  inputSampleRate: 8000,
}
